import { Especialidad } from '../data/types/especialidades.types'
 
export const getStringOfEspecialidades = (especialidadesString: string, allEspecialidades: Especialidad[]) => {
	if (!especialidadesString || especialidadesString?.length < 3) return ''
	if (especialidadesString === 'null') return ''
	// const especialidadesArray: number[] = JSON.parse(especialidadesString)
	const especialidadesIds = JSON.parse(especialidadesString)
	let especialidadesToReturn = ''
	for (let index = 0; index < especialidadesIds.length; index++) {
		const item = especialidadesIds[index];
		const newEspecialidad = allEspecialidades.find(e => e.id === item)
		if (newEspecialidad) {
			especialidadesToReturn = `${especialidadesToReturn}${especialidadesToReturn ? ', ' : ''}${newEspecialidad.nombre}`
		}
	}
	return especialidadesToReturn
}